(<any>window).__Zone_enable_cross_context_check = true;
(<any>window).__Zone_disable_requestAnimationFrame = true;
(<any>window).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mouseenter', 'mouseleave', 'mouseover', 'mouseout', 'mousewheel']
